import { render, staticRenderFns } from "./MainMenuElement.vue?vue&type=template&id=423af5f2&scoped=true&"
import script from "./MainMenuElement.vue?vue&type=script&lang=js&"
export * from "./MainMenuElement.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuElement.vue?vue&type=style&index=0&id=423af5f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423af5f2",
  null
  
)

component.options.__file = "MainMenuElement.vue"
export default component.exports